import { MapAdapter } from './types'
import { Location } from '../SearchLocation.types'

/**
 * Null adapter - no-op implementation for when map integration is disabled
 * This allows the component to work without any map provider
 */
export class NullAdapter implements MapAdapter {
  /**
   * Does nothing - no map to navigate
   */
  navigateToLocation(_location: Location): void {
    // No-op
  }

  /**
   * Always returns false - no map available
   */
  isAvailable(): boolean {
    return false
  }

  /**
   * Always returns null - no map instance
   */
  getMapInstance(): null {
    return null
  }
}

/**
 * Singleton instance of NullAdapter
 */
export const nullAdapter = new NullAdapter()
